import { Injectable } from "@angular/core";
import { Router, NavigationStart } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";


@Injectable({ providedIn: "root" })
export class AlertService {
  private subject = new Subject<any>();
  private keepAfterRouteChange = false;
  private snackBar: MatSnackBar;

  constructor(private router: Router,
             snackBar: MatSnackBar) {
    this.snackBar = snackBar;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterRouteChange) {
          // only keep for a single route change
          this.keepAfterRouteChange = false;
        } else {
          // clear alert message
          this.clear();
        }
      }
    });
  }

  getAlert(): Observable<any> {
    return this.subject.asObservable();
  }

  success(message: string, keepAfterRouteChange = false) {
    this.keepAfterRouteChange = keepAfterRouteChange;
    this.subject.next({ type: "success", text: message });
  }

  error(message: string, keepAfterRouteChange = false, keepOpen = false) {
    this.keepAfterRouteChange = keepAfterRouteChange;
    if (keepOpen) {
      this.snackBar.open(message, "Close", {
        panelClass: ['orange-snackbar']
      });
    }
    else {
      this.snackBar.open(message, "Close",
        {
          duration: 5000
        });
    }
    this.subject.next({ type: "error", text: message });
  }

  clear() {
    // clear by calling subject.next() without parameters
    this.subject.next();
  }
}
